import { ID } from "src/libs/interfaces/layouts"
import FieldInput from "src/libs/scalars"
import IScalarForm from "src/libs/scalars/interface/IScalarForm"
import LandingCompositeWidget from "src/modules/pe-landing-module/widgets/LandingCompositeWidget"
import LandingDimentionWidget from "src/modules/pe-landing-module/widgets/LandingDimentionWidget"

/* Protopia Ecosystem component */
export interface IFieldChangerProps extends IScalarForm { 
    dataSection: string
    dataName: string
    commentary?: string
    title: string
    subtitle: string
    type: string 
    sectionId?: ID
    notClear?: boolean
}
const FieldChanger = (props: IFieldChangerProps): JSX.Element => {
    const onChange = (value: any, field: string, dop: any) => {  
        if(props.onChange) {
            
            console.log( value, field, dop )
            
            props.onChange(value, field, dop)
        } 
    }
    const onCompositeChange = (value: any, field: string, dop: any) => {
        console.log( value, field, dop ) 
        onChange( value, field, dop )
    }
    switch( props.visualization ){
        case "landingCompositeDataType" :  
            return <LandingCompositeWidget {...props} onChange={onCompositeChange}/>
        case "landingDimention" :
            return <LandingDimentionWidget {...props} />
        default: 
            return <div className="my-1 ml-2"> 
                <FieldInput 
                    {...props} 
                    onChange={onChange}
                    title=""
                    subtitle={props.title || props.subtitle}
                /> 
            </div>
    } 
}
export default FieldChanger